export default __webpack_public_path__ + "static/media/doc-list-tick.b285ec38.svg";